import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const qobuz: MusicService = {
  id: 'qobuz',
  name: 'Qobuz',
  shortName: 'Qobuz',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#0070ef',
    label: '#0070EF',
    background: '#1d1e22',
  },
  importerID: ImporterID.Qobuz,
  musicAPIID: MusicAPIIntegrationID.Qobuz,
  linkType: 'qobuz',
  limits: {
    tracksPerPlaylist: 1000,
  },
  assets: {
    logo: { light: 'qobuz-light.svg', dark: 'qobuz-dark.svg' },
    logoPadding: { light: 'qobuz-light-padding.svg', dark: 'qobuz-dark-padding.svg' },
    logoColor: { light: 'qobuz-color-light.svg', dark: 'qobuz-color-dark.svg' },
    logoColorPadding: {
      light: 'qobuz-color-light-padding.svg',
      dark: 'qobuz-color-dark-padding.svg',
    },
    logoOnBackground: 'qobuz-dark.svg',
  },
  whatIsDescription: musicServiceMessages.qobuzWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: true,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: true,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: true,
    doesSupportRemovingArtistsFromLibrary: true,
    doesSupportSearchByISRC: false,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: true,
    doesReturnUserCountry: true,
    maxLimit: 500,
  },
};
